// import Butterfly from './Butterfly'
// import ButterflyModal from './ButterflyModal'
const Butterfly = r => require.ensure([], () => r(require('./Butterfly.vue')), 'butterfly-components-chunk')
const ButterflyModal = r => require.ensure([], () => r(require('./ButterflyModal.vue')), 'butterfly-components-chunk')

export { Butterfly, ButterflyModal }
